<script lang="ts">
    import {
        type FollowableInput,
        FollowableQueryDocument,
        FollowButtonFragmentDoc,
    } from '$gql/graphql.js';
    import { query } from '$lib/apollo/SvelteApollo.js';
    import FollowButton from '$components/FollowButton/FollowButton.svelte';
    import { useFragment } from '$gql';
    import { cx } from '$lib/utils/cx';
    import Spinner, { type SpinnerSize } from '$components/Spinner/Spinner.svelte';

    export let target: FollowableInput;

    let className = '';
    export { className as class };

    export let followedClassName = '';
    export let unfollowedClassName = '';
    export let spinnerClass = '';
    export let spinnerSize: SpinnerSize = 'xs';

    const { result, setVariables } = query(FollowableQueryDocument, {
        variables: {
            id: target,
        },
    });
    $: setVariables({ id: target });

    $: targetFollowable =
        useFragment(FollowButtonFragmentDoc, $result.data?.followable) ?? null;
</script>

{#if targetFollowable != null}
    <FollowButton
        class={className}
        {followedClassName}
        {unfollowedClassName}
        {spinnerClass}
        {spinnerSize}
        target={targetFollowable}
    />
{:else}
    <button class={cx(className, unfollowedClassName)} disabled data-not-followed={true}>
        <span class="flex items-center gap-x-2">
            <Spinner size={spinnerSize} class={spinnerClass} />
            <span>Suivre</span>
        </span>
    </button>
{/if}
